export enum Language {
    English = 0,
    Polish = 1,
}

export const LanguageNames: { [key: number]: string } = {
    [Language.English]: 'English',
    [Language.Polish]: 'Polish',
};
